import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

function fmtErr(detail) {
  if (!detail) return "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e.msg || JSON.stringify(e)).join(" ");
  return String(detail);
}

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(fmtErr(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="mx-auto flex min-h-[70vh] max-w-md flex-col justify-center px-5 py-20">
      <div className="eyebrow mb-3 text-gold">Editorial Access</div>
      <h1 className="font-serif text-4xl text-parchment">Sign in to the desk</h1>
      <p className="mt-3 text-sm text-faint">Restricted to COA editors and archivists.</p>

      <form onSubmit={submit} className="mt-10 space-y-5" data-testid="login-form">
        <div>
          <label className="eyebrow mb-2 block">Email</label>
          <input
            data-testid="login-email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className="w-full border border-line bg-surface px-4 py-3 text-parchment focus:border-gold focus:outline-none"
          />
        </div>
        <div>
          <label className="eyebrow mb-2 block">Password</label>
          <input
            data-testid="login-password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            className="w-full border border-line bg-surface px-4 py-3 text-parchment focus:border-gold focus:outline-none"
          />
        </div>
        {error && <p className="text-sm text-blood" data-testid="login-error">{error}</p>}
        <button
          type="submit"
          data-testid="login-submit"
          disabled={busy}
          className="w-full bg-gold py-3.5 text-sm font-semibold uppercase tracking-widest text-ink hover:bg-gold-hover disabled:opacity-60"
        >
          {busy ? "Signing in…" : "Enter"}
        </button>
      </form>
    </div>
  );
}
